import Lang from "../../../userPreferences/staticWords";
import { useEffect, useState } from "react";
import { resolver } from "../../../API/middlewares/resolveRequests";
import { useSelector } from "react-redux";
import CardWithTitleAndIcon from "../../reusableComponents/cardWithTitleButton";
import { customStyle, styleStart } from "../../../algorithms/styleDirection";
import { getProfileToggleLists } from "../../../API/store/actions/auth";
import PostCard from "./postCard";
import { ScrollToTop } from "../../../algorithms";
import PostForm from "./postForm";
import { AddPostIcon } from "../../community/icons";

const PostsIndex = ({ id, guestId }) => {
  const userLogged = useSelector((state) => state.login.userData);
  const communityId = useSelector((state) => state.community.communityId?.id);
  const userToken = useSelector((state) => state.login.userToken);

  const [data, setData] = useState(1);
  const [showComments, setShowComments] = useState({});

  const [show, setShow] = useState(false);
  const onShow = () => {
    setShow(true);
  };
  const [procAdded, setProcAdded] = useState(false);
  const [showBullets, setShowBullets] = useState({ id: null, display: false });

  const renderModal = () => {
    return (
      <PostForm
        userLogged={userLogged}
        userToken={userToken}
        communityId={communityId}
        setProcAdded={setProcAdded}
        procAdded={procAdded}
        show={show}
        onHide={() => setShow(false)}
        guestId={guestId}
      />
    );
  };

  useEffect(() => {
    resolver(
      getProfileToggleLists,
      setData,
      guestId ?? userLogged?.memberId,
      id,
      userToken
    );
    ScrollToTop();
  }, [userLogged, procAdded, guestId]);

  return (
    <div className="d-flex flex-column w-100">
      {/* small screens button */}
      <CardWithTitleAndIcon
        containerStyle="d-lg-none d-flex justify-content-center align-items-center col-12 mt-4 align-self-center"
        borderColor={"rgba(68, 68, 68, 0.25)"}
        height={90}
        width={200}
        onClick={() => {
          onShow();
        }}
        hasSVG={<AddPostIcon />}
        imgHeight={50}
        imgWidth={60}
        containerImgHeight={50}
        containerImgWidth={60}
        cardTitle={"إضافة منشور"}
        boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
      />

      <div className="d-flex flex-lg-row flex-column-reverse flex-wrap align-items-center">
        <div
          className={`d-flex flex-column align-self-center col-lg-8 col-10 ${styleStart(
            "m",
            4,
            "lg"
          )} mx-0`}
        >
          {data?.data?.map((item, index) => {
            return (
              <PostCard
                key={index}
                userToken={userToken}
                userLogged={userLogged}
                item={item}
                index={index}
                showComments={showComments}
                setShowComments={setShowComments}
                setProcAdded={setProcAdded}
                procAdded={procAdded}
                show={showBullets}
                setshow={setShowBullets}
              />
            );
          })}
        </div>
        <CardWithTitleAndIcon
          containerStyle={`d-lg-flex d-none flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 position-fixed ${customStyle(
            "createPost"
          )}`}
          borderColor={"rgba(68, 68, 68, 0.25)"}
          height={180}
          width={180}
          onClick={() => {
            onShow();
          }}
          hasSVG={<AddPostIcon />}
          imgHeight={70}
          imgWidth={80}
          containerImgHeight={70}
          containerImgWidth={80}
          cardTitle={"إضافة منشور"}
          boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
        />
      </div>
      {data?.data?.length > 0 ? null : (
        <div className="text-center container m-5">لا يوجد منشورات</div>
      )}
      {renderModal()}
    </div>
  );
};

export default PostsIndex;
